export function headerNav() {
    const $header = $(".header");
    const $body = $("body");
    const $headerSearchClose = $header.find(".header-search-close");
    const $headerSearchOpener = $header.find(".header-search-opener");
    const $themeToggle = $header.find(".header-theme-toggle");
    const $mobileMenuOpener = $header.find(".header-menu-opener");
    const languageSwitcherTitle = $header.find(".header-language-switcher-title");

    if (document.cookie.indexOf("cookieSiteTheme=") >= 0) {
        $body.addClass("dark-theme");
    } else if ($body.hasClass("dark-theme")) {
        if (document.cookie.indexOf("cookieSiteThemeWhite=") >= 0) {
            let expiry = new Date();
            expiry.setTime(expiry.getTime() + (1000 * 60 * 60 * 24 * 365));
            document.cookie = "cookieSiteTheme=yes; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
            document.cookie = "cookieSiteThemeWhite=yes; path=/; expires=" + expiry.toGMTString();
            $body.removeClass("dark-theme");
        } else {
            let expiry = new Date();
            expiry.setTime(expiry.getTime() + (1000 * 60 * 60 * 24 * 365));
            document.cookie = "cookieSiteTheme=yes; path=/; expires=" + expiry.toGMTString();
            document.cookie = "cookieSiteThemeWhite=yes; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
            $body.addClass("dark-theme");
        }
    }
    $mobileMenuOpener.on("click", function (e) {
        e.preventDefault();
        $body.toggleClass("menu-opened");
    });
    $themeToggle.on("click", function (e) {
        e.preventDefault();
        let expiry = new Date();
        expiry.setTime(expiry.getTime() + (1000 * 60 * 60 * 24 * 365));
        if ($body.hasClass("dark-theme")) {
            document.cookie = "cookieSiteTheme=yes; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
            document.cookie = "cookieSiteThemeWhite=yes; path=/; expires=" + expiry.toGMTString();
            $body.removeClass("dark-theme");
        } else {
            document.cookie = "cookieSiteTheme=yes; path=/; expires=" + expiry.toGMTString();
            document.cookie = "cookieSiteThemeWhite=yes; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
            $body.addClass("dark-theme");
        }
    });

    function focusAndOpenKeyboard(el, timeout) {
        if (!timeout) {
            timeout = 100;
        }
        if (el) {
            // Align temp input element approximately where the input element is
            // so the cursor doesn't jump around
            var __tempEl__ = document.createElement('input');
            __tempEl__.style.position = 'fixed';
            __tempEl__.style.top = '0';
            __tempEl__.style.left = '-9999px';
            __tempEl__.style.height = '0';
            __tempEl__.style.opacity = '0';
            __tempEl__.style.zIndex = '-1';
            __tempEl__.setAttribute('aria-hidden', 'true');
            // Put this temp element as a child of the page <body> and focus on it
            document.body.appendChild(__tempEl__);
            __tempEl__.focus();

            // The keyboard is open. Now do a delayed focus on the target element
            setTimeout(function () {
                el.focus();
                el.click();
                // Remove the temp element
                document.body.removeChild(__tempEl__);
            }, timeout);
        }
    }

    $headerSearchOpener.on("click touchstart", function (e) {
        e.preventDefault();
        $body.addClass("search-open");
        $body.removeClass("menu-opened");
        const $input = $header.find(".header-search input[type='text']");
        focusAndOpenKeyboard($input, 100);
    });
    $headerSearchClose.on("click", function (e) {
        e.preventDefault();
        $body.removeClass("search-open");
    });
    languageSwitcherTitle.on("click", function () {
        languageSwitcherTitle.toggleClass("list-opened");
    });
    $(document).on("click", function (e) {
        if (!$(e.target).closest(languageSwitcherTitle).length) {
            languageSwitcherTitle.removeClass("list-opened");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerNav.js